import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    tenants: [],
};

const tenantSlice = createSlice({
    name: "tenants",
    initialState,
    reducers: {
        setTenants: (state, action) => {
            state.tenants = action.payload;
        },
    }
});

export const { setTenants } = tenantSlice.actions;
export default tenantSlice.reducer;